import { Tag, Tooltip } from 'antd'
import { FC } from 'react'
import { getBrandLetter } from '../../helpers/entities/pantone/get-brand-letter'

interface PantoneBrandTagProps {
    manufacturerName?: string | null
}

/** Буква бренда пантона (S — SupraFlex, B — BIC), полное название — в подсказке. */
const PantoneBrandTag: FC<PantoneBrandTagProps> = ({ manufacturerName }) => {
    if (!manufacturerName) return null

    return (
        <Tooltip title={manufacturerName}>
            <Tag>{getBrandLetter(manufacturerName)}</Tag>
        </Tooltip>
    )
}

export default PantoneBrandTag
